export function makeAnimalItems(data) {
    const animals = data?.garrison?.animals ?? "";

    return [
        {
            label: "Animais",
            value: animals,
        },
    ];
}